import {
  Button,
  COLOR_VARIANTS,
  Icons,
  TYPOGRAPHY_VARIANT,
  Typography,
  VisualIcons,
} from '@tajawal/ct-web-design-system';
import Styled from './FareFamilyError.styled';
import { useTranslation } from 'react-i18next';
import { GenericCallback } from '@/types/common.types';

function FareFamilyError({ onReload }: { onReload: GenericCallback }): JSX.Element {
  const { t } = useTranslation();
  return (
    <Styled.Wrapper>
      <VisualIcons.ErrorIcon width="96" height="96" />
      <Typography sx={{ marginBottom: '8px', marginTop: '16px' }} variant={TYPOGRAPHY_VARIANT.HEADING2} component="h2">
        {t('FareFamilyCard.Error_Title')}
      </Typography>
      <Typography sx={{ marginBottom: '56px' }} align="center" variant={TYPOGRAPHY_VARIANT.BODY2} component="p">
        {t('FareFamilyCard.Error_Description')}
      </Typography>
      <Button
        startIcon={<Icons.ArrowsCounterClockwise width="16" height="16" color={COLOR_VARIANTS.AQUA100} />}
        fullWidth
        appearance="ghost"
        onClick={onReload}
      >
        {t('FareFamilyCard.Reload') as string}
      </Button>
    </Styled.Wrapper>
  );
}

export default FareFamilyError;
